<template>
	<div class="content">
        <router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "Content",
}
</script>

<style>
    .content {
        height:100%;
        width: 100%;
        grid-area: content;
        background-color: #efefef;
        padding: 0px;
        margin: 0;
        z-index: 3;
    }
</style>